import { createSlice } from "@reduxjs/toolkit";

const getAirLine = {};

const GetAirLineSlice = createSlice({
    name: "getAirLine",
    initialState: {
        getAirLine,
    },
    reducers: {
        reSetGetAirLine(state, action){
            state.getAirLine = {}
        },
        setGetAirLine(state, action) {
            state.getAirLine = action.payload;
        },
    },
});

export const {
    setGetAirLine,
    reSetGetAirLine
} = GetAirLineSlice.actions;

export default GetAirLineSlice.reducer;
